// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","tagArticle":"_1tlSi","thematic":"_2suEp","format":"_3vRyV","region":"_2KWgy"};